/**
 * @flow
 * @relayHash 83602ee8e6d641c157b40266f0318650
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type GovernorateUpdateInput = {|
  id: string,
  name: string,
  countryId: string,
|};
export type UpdateGovernorateMutationVariables = {|
  data: GovernorateUpdateInput
|};
export type UpdateGovernorateMutationResponse = {|
  +updateGovernorate: {|
    +id: string
  |}
|};
export type UpdateGovernorateMutation = {|
  variables: UpdateGovernorateMutationVariables,
  response: UpdateGovernorateMutationResponse,
|};
*/


/*
mutation UpdateGovernorateMutation(
  $data: GovernorateUpdateInput!
) {
  updateGovernorate(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "GovernorateUpdateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateGovernorate",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "GovernorateModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateGovernorateMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateGovernorateMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateGovernorateMutation",
    "id": null,
    "text": "mutation UpdateGovernorateMutation(\n  $data: GovernorateUpdateInput!\n) {\n  updateGovernorate(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b415351721f0f598daa37b2e0fa2ec6a';
module.exports = node;
